import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { List, WrapperAvatar, MenuItem, CustomIcon } from './styled';
import { RootState } from '../../../../store';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper/Paper';
import MedicalInformationOutlinedIcon from '@mui/icons-material/MedicalInformationOutlined';
import { ReactComponent as Prescriptions } from '../../../../images/prescription.svg';
import { ReactComponent as Exam } from '../../../../images/exam.svg';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import Typography from '@mui/material/Typography';
import Avatar from '../../Avatar';
import { useLogout } from '../../../../shared/hooks/';
import { customEventTracking } from '../../../../lib/gtm';

const MenuDesktop = () => {
  const {
    oyana: { me }
  } = useSelector((state: RootState) => state);
  const menuRef = useRef<HTMLButtonElement>(null);
  const [logOut] = useLogout();
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (menuRef.current && menuRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  return (
    <WrapperAvatar onMouseLeave={handleToggle} ref={menuRef}>
      {me && (
        <Avatar
          name={me.nickName?.length > 0 ? me.nickName : me.firstName}
          profileImage={me.profileImageThumbnail}
          onMouseEnter={handleToggle}
        />
      )}

      <List open={open} anchorEl={menuRef.current} role={undefined} placement="bottom-end" transition disablePortal>
        {({ TransitionProps, placement }) => {
          return (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom-end' ? 'top bottom' : 'left bottom'
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="composition-menu" aria-labelledby="composition-button">
                    <MenuItem
                      onClick={event => {
                        customEventTracking.send({
                          event: 'minhas_jornadas_mc'
                        });
                        handleClose(event);
                      }}
                    >
                      <Link to={'/'}>
                        <Typography variant="body2B">
                          <MedicalInformationOutlinedIcon />
                          Página inicial
                        </Typography>
                      </Link>
                    </MenuItem>
                    <MenuItem
                      onClick={event => {
                        customEventTracking.send({
                          event: 'meus_arquivos_mc'
                        });
                        handleClose(event);
                      }}
                    >
                      <Link to={'/meus-arquivos'}>
                        <Typography variant="body2B">
                          <CustomIcon>
                            <Prescriptions />
                          </CustomIcon>
                          Meus arquivos
                        </Typography>
                      </Link>
                    </MenuItem>
                    <MenuItem
                      onClick={event => {
                        customEventTracking.send({
                          event: 'meus_exames_mc'
                        });
                        handleClose(event);
                      }}
                    >
                      <Link to={'/meus-exames'}>
                        <Typography variant="body2B">
                          <CustomIcon>
                            <Exam />
                          </CustomIcon>
                          Meus exames
                        </Typography>
                      </Link>
                    </MenuItem>
                    <MenuItem
                      onClick={event => {
                        logOut();
                        handleClose(event);
                      }}
                    >
                      <Typography variant="body2B">
                        <LogoutOutlinedIcon />
                        Sair da conta
                      </Typography>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          );
        }}
      </List>
    </WrapperAvatar>
  );
};

export default MenuDesktop;
